module.exports = __webpack_public_path__ + "img/contenedor2.c177a804.png";